import { render, staticRenderFns } from "./UpgradeToProButton.vue?vue&type=template&id=45498ac7&scoped=true&"
import script from "./UpgradeToProButton.vue?vue&type=script&lang=js&"
export * from "./UpgradeToProButton.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeToProButton.vue?vue&type=style&index=0&id=45498ac7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45498ac7",
  null
  
)

export default component.exports